import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';
import { getStripeSecretKey } from './stripeActions';

export function getSignupOptionsSuccess(data) {
  return { type: types.GET_SIGNUP_OPTIONS_SUCCESS, data };
}

export function signup(data) {
  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/signup`, {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      return handleErrors(response);
    })
    .then((response) => {
      return response.json();
    })
    .then((response) => { // Not sure how to lint this as our arrow function will only redirect, not return
      if (response.data.plan.indexOf('basic') > -1) {
        // Basic plan - send them directly to the thank-you page
        window.location.href = `/thank-you?accountType=${data.plan}`;
      } else {
        const sessionId = response.data.session_id;
        return dispatch(getStripeSecretKey())
          .then((key) => {
            const stripe = Stripe(key);
            stripe.redirectToCheckout({ sessionId }).then(() => {
              // Checkout errors are passed to "then" not "catch"
            });
          });
      }
      return false;
    })
        .catch(response => response.json().then((res) => {
          dispatch(addNotification({
            message: res.message,
            level: 'error',
            autoDismiss: 0,
          }));
          throw res;
        }));
  };
}

export function getSignupOptions() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/signup`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(getSignupOptionsSuccess(res.data));
      });
    }).catch(response => response.json().then((res) => {
      throw res;
    }));
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/signupActions.js